import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import ResearchShowcaseFilterOption from './ResearchShowcaseFilterOption'

export type ResearchShowcaseFilterType = 'search' | 'multiselect'

export default class ResearchShowcaseFilter extends BaseModel {
  static override constructorName = 'ResearchShowcaseFilter'

  name: string = ''
  type: ResearchShowcaseFilterType = 'search'
  title: string = ''
  placeholder: string = ''
  items: ResearchShowcaseFilterOption[] = []
  includes: string[] = []
  'range_min': number = 0
  'range_max': number = 0
  'range_step': number = 0

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data, ['items'])

    this.items = convertToArrayModels(data.items, ResearchShowcaseFilterOption)
  }
}

registerModel(ResearchShowcaseFilter)
